import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FieldType, FieldTypeConfig} from "@ngx-formly/core";
import {UploadComponent} from "./upload/upload.component";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-formly-field-upload',
  standalone: true,
  imports: [CommonModule, UploadComponent, ReactiveFormsModule],
  template: `
    <div [ngClass]="formControl.hasError('required') && (formControl.touched || formControl.dirty)? 'must': ''">
      <app-upload [formControl]="formControl" [accept]="props['accept']"
                  [max]="props['max']" [uploadDesc]="props['label'] || ''"
                  [mandatory]="props['required'] || false"
                   [disableUpload]="props['disabled'] || false"
      ></app-upload>
      <span *ngIf="formControl.hasError('required') && (formControl.touched || formControl.dirty)" style="color: #ff4d4f">This field is required</span>
    </div>
  `,
  styles: [
    `.must {
      border: 1px solid red;
      padding: 15px 20px;

    }`

  ]
})
export class FormlyFieldUploadComponent extends FieldType<FieldTypeConfig> {



}
